import { GET_LOCATION_AND_IP } from "./types";

export const getLocationAndip = (data) => {
  return {
    type: GET_LOCATION_AND_IP,
    payload: data,
  };
};
